import i from "./td-longtail-vue-components254.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var r = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { staticClass: "extended-item-info", class: t.dynamicClass }, [s("div", { staticClass: "product-image" }, [t.image ? s(t.ImageElement, { attrs: { src: t.image.small, alt: t.image.name || "" } }) : e._e()], 1), s("div", { staticClass: "item-configurator" }, [s(t.SingleItemConfigurator, { attrs: { "is-accessible": e.isExtended, "bundle-item": e.bundleItem }, on: { "select-variant": (a) => e.$emit("select-variant", a) } })], 1)]);
}, m = [], o = /* @__PURE__ */ n(
  i,
  r,
  m,
  !1,
  null,
  "8bc282f0"
);
const f = o.exports;
export {
  f as default
};
